import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Error = () => {
  return (
    <Wrapper>
      <div>🤔</div>
      <h1>Error 404</h1>
      <p>Looks like you took a wrong turn</p>
      <Link to="/">
        <button className="btn">Back To Home</button>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 80vh;
  padding: 5% 5vw;
  > div {
    font-size: 6rem;
  }
  > h1 {
    font-size: 3rem;
  }
  p {
    margin-bottom: 2rem;
  }
`;

export default Error;
